<!--
  컨텐츠 영역 포함된 전체 레이아웃..
-->
<script setup>

import CommonHeader from "@/components/common/CommonHeader";
import DashboardAdBanner from "@/components/common/DashboardAdBanner.vue";
import CommonFooter from "@/components/common/CommonFooter.vue";

import {onMounted} from "vue";

//const isMobileMenu = ref(false)
/*
const toggleMobileMenu = (() => {
  console.log("toggleCallback......")
  if(isMobileMenu.value) isMobileMenu.value = false
  if(!isMobileMenu.value) isMobileMenu.value = true
})
*/

onMounted (() => {
  console.log("layoutContents.vue ==============================================")
})

</script>
<template>

  <!-- 세로 flex 레이아웃 : 뷰포트 높이를 채워 푸터가 항상 하단에 위치 -->
  <div class="layout_wrap">
    <CommonHeader></CommonHeader>
    <router-view></router-view>

    <!-- 전 페이지 공통 : 광고 영역 + 푸터 -->
    <div class="container ad_container">
      <div class="inwrap">
        <DashboardAdBanner/>
      </div>
    </div>
    <CommonFooter/>
  </div>

</template>

<style scoped>
.layout_wrap {display: flex;flex-direction: column;min-height: 100vh;}
.ad_container {padding-bottom: 0;}

/* 대시보드(메인) : 남는 높이를 상단 영역이 채우도록 하여 Full HD 에서 푸터까지 한 화면에 표시 */
@media (min-width: 769px) {
  .layout_wrap > :deep(.dash_container) {flex: 1 1 auto;display: flex;flex-direction: column;min-height: 0;}
  .layout_wrap > :deep(.dash_container) > .inwrap {flex: 1 1 auto;display: flex;flex-direction: column;min-height: 0;}
}
</style>
